function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 25.6,
  height: 32,
  rx: 2,
  fill: "#FFF0F0"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3.83984,
  y: 6.4,
  width: 15.36,
  height: 2.56,
  rx: 1.28,
  fill: "#FF4545"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 3.83984,
  y: 11.52,
  width: 15.36,
  height: 2.56,
  rx: 1.28,
  fill: "#FF4545"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 3.83984,
  y: 16.64,
  width: 7.68,
  height: 2.56,
  rx: 1.28,
  fill: "#FF4545"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.16133 28.04V24.4609H9.32099C9.76045 24.4609 10.0469 24.4788 10.1804 24.5146C10.3854 24.5683 10.5572 24.6855 10.6955 24.8662C10.8339 25.0452 10.903 25.2771 10.903 25.562C10.903 25.7817 10.8631 25.9664 10.7834 26.1162C10.7036 26.2659 10.6019 26.3839 10.4782 26.4702C10.3561 26.5548 10.2316 26.611 10.1047 26.6386C9.93216 26.6728 9.68232 26.6899 9.35517 26.6899H8.88398V28.04H8.16133ZM8.88398 25.0664V26.082H9.27949C9.56432 26.082 9.75475 26.0633 9.85078 26.0258C9.94681 25.9884 10.0217 25.9298 10.0754 25.8501C10.1307 25.7703 10.1584 25.6775 10.1584 25.5717C10.1584 25.4415 10.1201 25.3341 10.0436 25.2495C9.96715 25.1648 9.87031 25.1119 9.75312 25.0908C9.66686 25.0745 9.49352 25.0664 9.2331 25.0664H8.88398ZM11.4938 24.4609H12.8146C13.1125 24.4609 13.3395 24.4837 13.4958 24.5293C13.7058 24.5911 13.8856 24.701 14.0353 24.8588C14.1851 25.0167 14.299 25.2104 14.3771 25.4399C14.4553 25.6678 14.4943 25.9493 14.4943 26.2846C14.4943 26.5792 14.4577 26.8331 14.3845 27.0463C14.295 27.3068 14.1672 27.5175 14.0012 27.6787C13.8758 27.8007 13.7066 27.896 13.4934 27.9643C13.3339 28.0148 13.1206 28.04 12.8537 28.04H11.4938V24.4609ZM12.2165 25.0664V27.437H12.7561C12.9579 27.437 13.1035 27.4256 13.1931 27.4028C13.3103 27.3735 13.4071 27.3239 13.4836 27.2539C13.5617 27.1839 13.6252 27.0691 13.674 26.9096C13.7228 26.7485 13.7473 26.5296 13.7473 26.2529C13.7473 25.9762 13.7228 25.7638 13.674 25.6157C13.6252 25.4676 13.5568 25.352 13.4689 25.269C13.3811 25.186 13.2696 25.1298 13.1345 25.1005C13.0336 25.0778 12.8358 25.0664 12.5412 25.0664H12.2165ZM15.1145 28.04V24.4609H17.5681V25.0664H15.8371V25.9135H17.3312V26.519H15.8371V28.04H15.1145Z",
  fill: "#FF4545"
});

function SvgIconTinyFormatPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTinyFormatPdf);
export default __webpack_public_path__ + "static/media/icon-tiny-format-pdf.3db8ac89.svg";
export { ForwardRef as ReactComponent };